// Docs: https://vuetifyjs.com/en/getting-started/quick-start/
// Colors Doc: https://vuetifyjs.com/en/styles/colors/
// Theme Doc: https://vuetifyjs.com/en/customization/theme/

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// themes light setting should be same as src/assets/variables/themes.scss
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1e50c0', // 'brand-01-emphasis'

        'brand-01-emphasis': '#1e50c0',
        'brand-02-medium': '#7d9de6',
        'brand-03-disabled': '#e8efff',
        'brand-04-reversed': '#ffffff',
        'danger-01-emphasis': '#f60000',
        'danger-02-medium': '#ffacac',
        'danger-03-disabled': '#ffe7e7',
        'danger-04-reversed': '#ffffff',
        'ink-01-emphasis': '#353e4d',
        'ink-02-medium': '#848fa0',
        'ink-03-disabled': '#abb8c8',
        'ink-04-reversed': '#ffffff',

        'brand-emphasis': '#1e50c0',
        'brand-medium': '#7d9de6',
        'brand-disabled': '#e8efff',
        'brand-reversed': '#ffffff',
        'danger-emphasis': '#f60000',
        'danger-medium': '#ffacac',
        'danger-disabled': '#ffe7e7',
        'danger-reversed': '#ffffff',
        'ink-emphasis': '#353e4d',
        'ink-medium': '#848fa0',
        'ink-disabled': '#abb8c8',
        'ink-reversed': '#ffffff',

        'brand-100': '#e8efff',
        'brand-200': '#b8cdfb',
        'brand-300': '#7d9de6',
        'brand-400': '#376adb',
        'brand-500': '#1e50c0',
        'brand-600': '#1240a8',
        'brand-700': '#133787',
        'brand-800': '#082971',
        'brand-900': '#041d57',

        'gray-100': '#f7fafc',
        'gray-200': '#e7ecf3',
        'gray-300': '#d7dee7',
        'gray-400': '#c1cbd7',
        'gray-500': '#abb8c8',
        'gray-600': '#848fa0',
        'gray-700': '#5f697a',
        'gray-800': '#4a5363',
        'gray-900': '#353e4d',

        'danger-100': '#ffe7e7',
        'danger-200': '#ffacac',
        'danger-300': '#fe7e7e',
        'danger-400': '#f94848',
        'danger-500': '#f30000',
        'danger-600': '#dc0000',
        'danger-700': '#bd0000',
        'danger-800': '#840000',
        'danger-900': '#4e0000',

        'success-100': '#e6ffc9',
        'success-200': '#c0e98f',
        'success-300': '#aee36f',
        'success-400': '#96d44f',
        'success-500': '#88c640',
        'success-600': '#609f16',
        'success-700': '#3e7103',
        'success-800': '#223e00',
        'success-900': '#132400',

        'warning-100': '#fff4c7',
        'warning-200': '#ffeda7',
        'warning-300': '#ffe686',
        'warning-400': '#ffde5d',
        'warning-500': '#f5c816',
        'warning-600': '#a28924',
        'warning-700': '#66540a',
        'warning-800': '#463802',
        'warning-900': '#2c2300',
      },
    },
  },
});
